// KLCNS 웹소켓 통신 시 주고받는 이벤트 타입 정의

export default {
  START_MONITOR: 'startMonitor', // cg 자체 이벤트 타입

  PING: 'Ping', // 소켓 Ping 확인
  PING_ACTION: 'PingAction', // 소켓 Ping 확인 결과 반환
  GET_AGENT_STATE: 'GetAgentState', // 상담원 CTI 상태 조회
  GET_AGENT_STATE_ACTION: 'GetAgentStateAction', // 상담원 CTI 상태 조회 결과 반환
  SET_AGENT_STATE: 'SetAgentState', // 상담원 CTI 상태 변경
  SET_AGENT_STATE_ACTION: 'SetAgentStateAction', // 상담원 CTI 상태 변경 결과 반환
  ORIGINATE: 'Originate', // 전화걸기
  ORIGINATE_ACTION: 'OriginateAction', // 전화걸기 결과 반환
  ANSWER: 'Answer', // 전화받기
  ANSWER_ACTION: 'AnswerAction', // 전화받기 결과 반환
  HANG_UP: 'Hangup', // 전화 끊기
  HANG_UP_ACTION: 'HangupAction', // 전화 끊기 결과 반환
  AT_XFER: 'Atxfer', // 돌려주기 (협의)
  ATXFER_ACTION: 'AtxferAction',
  BLIND_XFER: 'Blindxfer',
  BLIND_XFER_ACTION: 'BlindTransferAction',
  CANCEL_AT_XFER: 'CancelAtxfer',
  CANCEL_AT_XFER_ACTION: 'CancelAtxferAction',
  HOLD_AUDIO: 'HoldAudio',
  HOLD_AUDIO_ACTION: 'HoldAudioAction',
  MUTE_AUDIO: 'MuteAudio',
  MUTE_AUDIO_ACTION: 'MuteAudioAction',
  GET_USER_EVENT: 'GetUserEvent',
  RINGING: 'Ringing',
  BRIDGE: 'Bridge',
  TRANSFER_ANSWER: 'TransferAnswer',
  SPY_CALL: 'SpyCall',
  SPY_CALL_ACTION: 'SpyCallAction',
  SPY_STOP: 'SpyStop'
};



// WEBPACK FOOTER //
// ./src/constants/klcnsEvent.js